import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M0 2.188h6.094l.468.937H.47zm.625 1.874h6.094L7.187 5H1.095zm10.156 5a.936.936 0 1 0 0-1.874.936.936 0 1 0 0 1.875m.938-5.624h-1.563V5h2.788zM4.53 9.061a.936.936 0 0 0 .938-.937.936.936 0 0 0-.938-.937.936.936 0 0 0-.937.937c0 .519.419.938.937.938m7.5-6.562L13.906 5v3.125h-1.25A1.87 1.87 0 0 1 10.781 10a1.87 1.87 0 0 1-1.875-1.875h-2.5A1.876 1.876 0 0 1 4.531 10a1.87 1.87 0 0 1-1.875-1.875h-1.25V5.938h1.25v.937h.475a1.883 1.883 0 0 1 2.8 0h2.975V1.25h-7.5c0-.694.557-1.25 1.25-1.25h7.5v2.5z"
    }, null, -1)
  ])))
}
export default { render: render }